var _excluded = ["children", "icon", "theme", "small"];

var _templateObject;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled, { withTheme } from 'styled-components';
import { func, oneOf, node, bool } from 'prop-types';
import { margins } from '@gympass/yoga-system';
import Tag from './Tag';
import Icon from '../../Icon';
var Informative = styled(Tag)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  justify-content: center;\n  align-items: center;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
      _ref$theme$yoga = _ref.theme.yoga,
      _ref$theme$yoga$color = _ref$theme$yoga.colors,
      text = _ref$theme$yoga$color.text,
      _ref$theme$yoga$color2 = _ref$theme$yoga$color.feedback[variant],
      color = _ref$theme$yoga$color2 === void 0 ? {
    light: text.secondary
  } : _ref$theme$yoga$color2,
      tag = _ref$theme$yoga.components.tag;
  return "\n    background-color: " + color.light + ";\n    color: " + text.primary + ";\n    border-radius: " + tag.border.radius + "px;\n    border-color: " + color.light + ";\n\n    font-size: " + tag.font.size + "px;\n    font-weight: " + tag.font.weight + ";\n  ";
}, margins);
/** Tags should be keywords to categorize or organize an item. */

var TagInformative = function TagInformative(_ref2) {
  var children = _ref2.children,
      icon = _ref2.icon,
      _ref2$theme$yoga = _ref2.theme.yoga,
      text = _ref2$theme$yoga.colors.text,
      tag = _ref2$theme$yoga.components.tag,
      small = _ref2.small,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Informative, _extends({
    small: small
  }, props), icon && /*#__PURE__*/React.createElement(Icon, {
    as: icon,
    size: small ? tag.icon.size.small : tag.icon.size["default"],
    fill: text.primary,
    marginRight: tag.icon.margin.right
  }), children);
};

TagInformative.propTypes = {
  /** Values: neutral, success, informative, attention */
  variant: oneOf(['neutral', 'success', 'informative', 'attention']),

  /** Icon reference from our library */
  icon: func,

  /** The tag's content */
  children: node.isRequired,

  /** The tag's size */
  small: bool
};
TagInformative.defaultProps = {
  icon: undefined,
  small: false,
  variant: 'neutral'
};
TagInformative.displayName = 'Tag.Informative';
export default withTheme(TagInformative);